import axios from 'axios';

export const creditorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-creditor`,
    headers: {
        'Content-Type': 'application/json'
    }
})